import { BooLogo } from "@/components/BooLogo";
import { SetupChecklist } from "@/components/SetupChecklist";
import type { SetupConditions } from "@/lib/setup-progress";

// Shared "your Boo is being set up" UI: the pulsing logo, and its setup as
// a checklist once the backend reports conditions for it. Used by both the
// onboarding ProvisioningStep (post-workspace submit) and the dashboard's
// new-container post-create view.
export function BrainProvisioningStatus({
  botName,
  subheading,
  conditions,
  showDetails,
}: {
  botName: string;
  subheading?: string;
  conditions?: SetupConditions;
  // Staff see why a step isn't done yet.
  showDetails?: boolean;
}) {
  return (
    <div className="flex flex-col gap-8 items-center justify-center text-center py-8">
      <div className="relative">
        <span
          className="boo-pulse absolute -inset-8 rounded-full"
          style={{
            background:
              "radial-gradient(closest-side, rgba(127, 119, 221, 0.45), transparent 70%)",
          }}
        />
        <span
          className="boo-pulse absolute -inset-12 rounded-full"
          style={{
            background:
              "radial-gradient(closest-side, rgba(212, 83, 126, 0.25), transparent 70%)",
            animationDelay: "400ms",
          }}
        />
        <BooLogo className="relative size-20 rounded-2xl" />
      </div>
      <div className="space-y-2 max-w-sm">
        <h1 className="text-2xl font-semibold">Setting up {botName}…</h1>
        <p className="text-sm text-muted-foreground">
          {subheading ?? "This usually takes about a minute."}
        </p>
      </div>
      <SetupChecklist conditions={conditions} showDetails={showDetails} />
    </div>
  );
}
